import { type Product, ProductType } from '../api/product/types';
import { BuyButtonButton } from './BuyButton';
import { BuyButtonPriceLabel } from './BuyButtonPriceLabel';
import { getMonthPrice } from './priceUtils';
import { extractUrlParameters } from './urlUtils';

interface Props {
    userLocale: string;
    showPrice: boolean;
    disableButton: boolean;
    showButton: boolean;
    product?: Product;
}

export const BuyButtonContent = (props: Props) => {
    const { product, userLocale, showPrice, disableButton, showButton } = props;
    const { buttonLeft } = extractUrlParameters(window.location.href);
    const price = product?.price;
    const monthPrice = getMonthPrice(price, userLocale, product?.currency);
    const productType = product?.productType;

    return (
        <div className={`buyButton align-items-start${buttonLeft ? ' flex-row-reverse' : ''}`}>
            <BuyButtonPriceLabel
                showPrice={showPrice}
                monthPrice={monthPrice}
                productType={productType ?? ProductType.ASSET}
            />
            {showButton && <BuyButtonButton disabled={disableButton} product={product} />}
        </div>
    );
};
